import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../services/user-data-store.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MerchantService } from "../services/merchant.service";
import { Router } from '@angular/router';
import { PermissionEnum, AccessPolicyEnum } from "../services/guards/permissions";
import { AuthenticationService } from "../services/authentication.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { DataTablesResponseViewModel } from '../models/data-tables-response-view-model';
import { environment } from '../../environments/environment';
import { MerchantReportDTViewModel } from '../models/merchant-report-dt-view-model';
import { ToastrService } from 'ngx-toastr';
import { CreditBalanceViewModel } from '../models/credit-balance-view-model';
import { CreateResult } from '../models/create-result';
import { CreditService } from '../services/credit.service';

@Component({
  selector: 'app-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.scss']
})

export class CreditComponent implements OnInit {

  public dtTrigger: Subject<boolean> = new Subject();
  public merchants: MerchantReportDTViewModel[] = [];
  public searchDebounce = new Subject<string>();


  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  public canManage = false;
  public raiseDanger: boolean = false;
  public raiseWarning: boolean = false;
  public success: boolean = false;
  public message: string;
  public danger: string;
  public warning: string;
  public PAN: string;
  public editView: string;
  public creditBalance: CreateResult;

  constructor(
    private _httpClient: HttpClient,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _creditService: CreditService,
    private _ngxUiLoaderService: NgxUiLoaderService, private _toastService: ToastrService) {

    this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewCredit]);
    if (!this.canManage) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }

  }


  ngOnInit() {

  }



  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  public async submit(): Promise<void> {

    if (this.PAN == undefined) {
      this.raiseDanger = true;
      this.danger = "Card Number is required!";
      this.success = false;
    }
    else if (this.PAN.length < 12 || this.PAN.length > 19) {
      this.raiseDanger = true;
      this.danger = "Card Number must be between 12 and 19 digits";
      this.success = false;
    }
    else {

      let x: number = Number(this.PAN);

      if (Number.isNaN(x)) {
        this.raiseDanger = true;
        this.danger = "Card number should consist of digits only.";
        this.success = false;
      }
      else {

        this._ngxUiLoaderService.start();

        //var result: any = await this._creditService.GetBalance(this.PAN);
        var result: CreateResult = await this._creditService.GetCreditBalance(this.PAN);

        if (result != null) {

          if (result.success) {
            var balance: number = 0;
            if (result.message != null && result.message != '') {
              balance = parseInt(result.message) / 100;
            }
            this.raiseDanger = false;
            this.success = true;
            this.message = "Balance for card number '" + this.PAN + "' is R" + balance.toFixed(2);
          }
          else {
            this.raiseDanger = true;
            this.danger = result.message;
            this.success = false;
          }
        }
        else {
          this.raiseDanger = true;
          this.danger = "Error occured while retrieving credit balance. Please contact system administrator.";
          this.success = false;
        }
        this._ngxUiLoaderService.stop();
      }
    }
  }

}
